import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, GlobalStyles, Toaster, theme as appTheme } from '@tviklax/ui-components';
import { apolloClient } from './shared/graphql/client';
import { UserProvider } from './context/UserContext';
import { ApplicationProvider } from './context/ApplicationProvider';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApplicationProvider>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider>
          <GlobalStyles theme={appTheme} />
          <UserProvider>
            <App />
          </UserProvider>
          <Toaster />
        </ThemeProvider>
      </ApolloProvider>
    </ApplicationProvider>
  </React.StrictMode>
);
